import { Component, ContentType } from 'contensis-core-api';
import { Entry } from 'contensis-management-api';
import { Model } from './Model';
import {
  EntryDependencyMeta,
  EntryDependencyOrigin,
} from './EntryDependencies';
import { EntryBuilder } from '~/transformations/EntryBuilder';

export type MigrateEntryModel = {
  contentType?: ContentType;
  components: Component[];
  model?: Model;
  sourceEntry: Entry;
  dependencies: EntryDependencyMeta[];
  dependencyOf: EntryDependencyOrigin[];
};

/**
 * A built entry with the Contensis-controlled fields nulled out, ready to
 * compare with an existing entry (`nullFields` on the entry builders)
 */
export type NulledEntry = Omit<Entry, 'sys'> & { sys: null };

export type BuildEntryOptions = {
  ignoreErrors: boolean;
  outputProgress?: boolean;
  onError: (migrateEntry: EntryBuilder) => void;
};
